export default "__VITE_ASSET__Bo9b89U1__"